import React, { useEffect, useRef } from 'react';

const GlobalCursorEffect = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (containerRef.current) {
                const x = (e.clientX / window.innerWidth) * 100;
                const y = (e.clientY / window.innerHeight) * 100;
                
                // Directly update CSS variables on the DOM element
                // This is extremely efficient compared to React state updates
                containerRef.current.style.setProperty('--mouse-x', `${x}%`);
                containerRef.current.style.setProperty('--mouse-y', `${y}%`);
                containerRef.current.style.setProperty('--mouse-x-inv', `${100 - x}%`);
                containerRef.current.style.setProperty('--mouse-y-inv', `${100 - y}%`);
            }
        };

        window.addEventListener('mousemove', handleMouseMove, { passive: true });
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div 
            ref={containerRef}
            className="fixed inset-0 pointer-events-none z-[1] overflow-hidden"
            style={{
                '--mouse-x': '50%',
                '--mouse-y': '50%',
                '--mouse-x-inv': '50%',
                '--mouse-y-inv': '50%',
            }}
        >
            {/* Primary Blue Glow */}
            <div 
                className="absolute inset-0 opacity-20 dark:opacity-30 transition-all duration-300 ease-out"
                style={{
                    background: `radial-gradient(circle 800px at var(--mouse-x) var(--mouse-y), var(--color-primary) 0%, transparent 60%)`,
                    filter: 'blur(80px)'
                }}
            />
            
            {/* Secondary Accent Glow */}
            <div 
                className="absolute inset-0 opacity-10 dark:opacity-15 transition-all duration-500 ease-out"
                style={{
                    background: `radial-gradient(circle 600px at var(--mouse-x-inv) var(--mouse-y-inv), var(--color-accent) 0%, transparent 50%)`,
                    filter: 'blur(100px)'
                }}
            />
        </div>
    );
};

export default GlobalCursorEffect;
